



























import { Component, Vue } from 'vue-property-decorator';
import TextInput from "@/components/TextInput.vue"
import { Credentials } from "../models/credentials.model";
import { mapState, mapGetters } from 'vuex';
import SyncLoader from 'vue-spinner/src/SyncLoader.vue';
import store from "@/store/store";

@Component({
    components:{ 
        TextInput
        , SyncLoader
    },
    computed: mapState("auth",{ companyId: 'companyId' }),
})
export default class LoginPage extends Vue{

    // color:string = "#C44536";

    companyId!:string;

    credentials: Credentials = {userName:"", password:""};

    created(){

    }


    get loading():boolean{
        return this.$store.getters["app/loading"];
    }

  async handleLogin() {
        this.$store.dispatch('auth/authRequest', this.credentials).then((result) => {
            this.$store.dispatch('app/getCompanyInfoFromKey', this.companyId).then((resolve)=>{
                this.$store.dispatch("app/getSetting", store.getters["app/companyId"]).then(() =>{
                    this.$router.push('/pinboard');
                });
            });

        }).catch((err) => {
            store.dispatch("app/setLoading", false);
            this.$notify({
                group: 'message',
                title: 'Login misslyckades',
                text: 'Kontrollera ditt användarnamn och lösenord',
                duration: 7000,
                type: 'error',
            });
        });
  }
}

// const vm = new Vue()
// // Connect to an alternative websocket URL and Options e.g.
//     vm.$connect('ws://localhost:44314/notifications', { format: 'json' });
